import _ from "lodash"

export default {
  chunk: (array = [], amountOfSize = 500) => {
    return _.chunk(array, amountOfSize)
  },
}
